import { render } from "./RequiredMetadataColumnMapping.vue?vue&type=template&id=2d8cbae7&scoped=true"
import script from "./RequiredMetadataColumnMapping.vue?vue&type=script&lang=js"
export * from "./RequiredMetadataColumnMapping.vue?vue&type=script&lang=js"

import "./RequiredMetadataColumnMapping.vue?vue&type=style&index=0&id=2d8cbae7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8cbae7"]])

export default __exports__